<script setup lang="ts">
import { Field, Form } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import { onMounted, ref } from 'vue'
import { useMyFetch } from '@/utils'
import { useRouter } from 'vue-router'
import { useAlertStore, useAuthStore } from '@/store'
import * as yup from 'yup'
import { handleError } from '@/utils/errors'

const { t } = useI18n()
const material = ref('')

const alertStore = useAlertStore()
const router = useRouter()
const authStore = useAuthStore()

const schema = yup.object({
  material: yup
    .string()
    .required()
    .test('material', t('invalid_key_type'), (value) => {
      return value.startsWith('ssh-rsa') || value.startsWith('ssh-ed25519')
    })
})

async function onSubmit() {
  const { error } = await useMyFetch('profile/keys')
    .post({
      material: material.value
    })
    .json()
  if (error.value) {
    await handleError(error, router, authStore, alertStore)
  } else {
    await router.push({ name: 'account:keys:list' })
  }
}
</script>

<i18n lang="yaml">
en:
  invalid_key_type: Invalid key type; expected ssh-rsa or ssh-ed25519
  material: Public key
  help_location: Usually it can be found in file
  or: or
  save: Save
ru:
  invalid_key_type: Неправильный тип ключа; ожидается ssh-rsa или ssh-ed25519
  material: Публичный ключ
  help_location: Обычно он хранится в файле
  or: или
  save: Сохранить
</i18n>

<template>
  <div class="card-body">
    <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors, isSubmitting }">
      <div class="form-group mb-3">
        <div>{{ t('material') }}</div>
        <div class="mt-2">
          {{ t('help_location') }} <kbd>~/.ssh/id_rsa.pub</kbd> {{ t('or') }}
          <kbd>~/.ssh/id_ed25519.pub</kbd>
        </div>
        <Field
          v-focus
          v-model="material"
          name="material"
          type="text"
          class="form-control mt-2"
          placeholder="ssh-rsa ... | ssh-ed25519 ..."
          :class="{ 'is-invalid': errors.material }"
          :validateOnBlur="false"
        />
        <div class="invalid-feedback">{{ errors.material }}</div>
      </div>
      <div class="form-group mb-3">
        <button class="btn btn-primary" type="submit">
          <span v-show="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
          {{ t('save') }}
        </button>
      </div>
    </Form>
  </div>
</template>
